import React from 'react';
//import patient from '../../../../../../../../patient.svg'
import AddPaymentModal from '../add-pay-modal/index';
import EditPatientModal from '../edit-patient-modal';
const images = require("../../../../../../../../images.json");
const patient = images.patient

export default class PatientInfo extends React.Component {
    state = {
        modal: ""
    }

    openModal = (modal) => this.setState({modal: modal})
    closeModal = () => this.setState({modal: ""})

    render() {
        return (
            <div className="PatientInfo">
                <div className="card">
                    <div className="card-header">
                        <h2 className="card-header-title">
                            Cliente
                        </h2>
                        <a className={"card-header-icon header-button"}
                            onClick={() => this.openModal("edit-patient")}
                        >
                            Editar cliente
                        </a>
                        <a className={"card-header-icon header-button"}
                            onClick={() => this.openModal("add-payment")}
                        >
                            Agregar pago
                        </a>
                    </div>
                    <div className="card-content">
                        <div className="content">
                            <div className="avatar">
                                <figure className="image is-96x96">
                                    <img src={patient} />
                                </figure>
                            </div>
                            <div className="name">
                                <p>
                                    <b>Nombre: </b>
                                    {`${this.props.patient.name} ${this.props.patient.lastname}`}
                                </p>
                                {this.props.patient.phone &&
                                <p>
                                    <b>Teléfono: </b>
                                    {this.props.patient.phone}
                                </p>}
                            </div>
                        </div>
                    </div>
                </div>
                <AddPaymentModal user={this.props.user} patient={this.props.patient} close={this.closeModal} isActive={this.state.modal == "add-payment"} />
                <EditPatientModal {...this.props} close={this.closeModal} isActive={this.state.modal == "edit-patient"} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patient-details/components/patient-info/index.js